import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      {/* <div>
        <a
          href="https://github.com/trgoti2812"
          target="_blank"
          rel="noreferrer"
        >
          <GitHubIcon />
        </a>
        <a
          href="https://www.linkedin.com/in/tirth-goti-0066432b1"
          target="_blank"
          rel="noreferrer"
        >
          <LinkedInIcon />
        </a>
      </div> */}
      <p>
        A portfolio designed & built by{" "}
        <a
          href="https://github.com/yujisatojr/react-portfolio-template"
          target="_blank"
          rel="noreferrer"
        >
          Utsav Ghelani
        </a>
      </p>
    </footer>
  );
}

export default Footer;
